export const OMNITURE_ACCOUNT = 'mmtprod';

export const QUEUE_MAX_RETRIES = 10;
export const QUEUE_RETRY_INTERVAL_MS = 100;
